<script setup>
import { useI18n } from 'vue-i18n';
import { ScrollFloat } from '@/components/vuebits';

defineProps({
  /** 章节主标题 */
  title: {
    type: String,
    required: true,
  },
  /** 章节副标题（可选） */
  subtitle: {
    type: String,
    default: '',
  },
});

const { locale } = useI18n();
</script>

<template>
  <div class="mb-12 text-center">
    <!-- key 保证切换语言后 ScrollFloat 重新初始化 -->
    <ScrollFloat
      :key="`${locale}-${title}`"
      container-class-name="my-0 flex justify-center"
      text-class-name="text-foreground font-bold !text-[clamp(1.75rem,4vw,2.25rem)] leading-tight"
      :stagger="0.04"
    >
      {{ title }}
    </ScrollFloat>
    <p v-if="subtitle" class="mt-3 text-muted-foreground">
      {{ subtitle }}
    </p>
  </div>
</template>
